import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const BetslipFooterContainer = styled('div', { label: 'BetslipFooterContainer' })`
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: 8px;
`;

export const ReturnsWrapper = withConfig(theme => styled('div', { label: 'ReturnsWrapper' })`
    align-items: baseline;
    color: ${theme.star.betslipGeneral.txtColor};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-bottom: 4px;
`);

export const ReturnsLabel = withConfig(theme => styled('span', { label: 'ReturnsLabel' })`
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.2;
`);

export const ReturnsValue = withConfig(theme => styled('i', { label: 'ReturnsValue' })`
    color: ${theme.star.betslipGeneral.txtColorTertiary};
    font-size: ${theme.star.fontSize.small};
    font-style: normal;
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3334;
`);

export const BalanceValue = withConfig(theme => styled(ReturnsValue, { label: 'BalanceValue' })`
    color: ${theme.star.betslipGeneral.txtColor};
`);
